export default {
  title: {
    en: 'Search for sport events, leagues...',
  },
}
